<template>
  <div>
    <page-title
      icon="ni ni-tv-2"
      main="Pedidos"
      sub="Liberações comerciais"
      :help="true"
      titleHelp="Página responsável pela listagem de Liberações comerciais"
      content="Página responsável por aprovar ou desaprovar liberações comerciais.
Para aprovação/desaprovação é necessário uma Alçada compatível com a porcentagem de desconto do pedido."
    ></page-title>
    <modal :show.sync="modals.modal1" id="confirmar-liberacao">
      <template slot="header">
        <h2 id="exampleModalLabel">Confirmar Liberação Comercial</h2>
      </template>

      <p style="font-size: 20px;">Deseja Aprovar a Liberação Comercial?</p>
      <div :class="{ 'invalid': typeIsInvalid }">
        <textarea
          v-model="description"
          class="form-control"
          rows="3"
          placeholder="Por favor informe o motivo"
        ></textarea>
        <div
          class="invalid-feedback"
          v-show="typeIsInvalid"
          style="display: block;"
        >
          Campo Obrigatório
        </div>
      </div>
      <template slot="footer">
        <base-button type="success" @click="approve">Confirmar</base-button>
      </template>
    </modal>
    <modal :show.sync="modals.modal2" id="confirmar-liberacao">
      <template slot="header">
        <h2 id="exampleModalLabel">Confirmar Liberação Comercial</h2>
      </template>

      <p style="font-size: 20px;">Deseja Reprovar a Liberação Comercial?</p>

      <div :class="{ 'invalid': typeIsInvalid }">
        <textarea
          v-model="description"
          class="form-control"
          rows="3"
          placeholder="Por favor informe o motivo"
        ></textarea>
        <div
          class="invalid-feedback"
          v-show="typeIsInvalid"
          style="display: block;"
        >
          Campo Obrigatório
        </div>
      </div>

      <template slot="footer">
        <base-button type="success" @click="disapprove">Confirmar</base-button>
      </template>
    </modal>
    <modal :show.sync="modals.commercialReleaseDetailsModal" id="confirmar-liberacao">
      <template slot="header">
        <h2 id="exampleModalLabel">Detalhes do Pedido de Venda</h2>
      </template>

      <commercial-release-details :commercial-release="currentOrder" :order-items="orderItems" :purchase-order="commercialDetailsOrders" />

      <template slot="footer">
        <base-button type="secondary" @click="modals.commercialReleaseDetailsModal = false">Fechar</base-button>
        <base-button type="warning" @click="modals.commercialReleaseDetailsModal = false;openModalDisapproval(currentOrder.id)">Reprovar</base-button>
        <base-button type="success" @click="modals.commercialReleaseDetailsModal = false;openModalApprove(currentOrder)">Aprovar</base-button>
      </template>
    </modal>
    <card class="card mt-2">
      <div slot="header">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 form-group">
            <label class="form-control-label d-block">Data de Início</label><br />
            <el-date-picker
              v-model="filter.created_at"
              prefix-icon="fa fa-calendar"
              format="d 'de' MMMM 'de' yyyy"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-sm-12 col-md-4 form-group ">
              <label class="form-control-label d-block">Data de Fim</label><br />
              <el-date-picker
                v-model="filter.end_date"
                prefix-icon="fa fa-calendar"
                format="d 'de' MMMM 'de' yyyy"
              >
              </el-date-picker>
          </div>
          <div class="col-12 col-md-4 mb-4">
            <div style="margin-top: 3.2rem;">
              <base-button
                v-loading="isLoading"
                icon
                type="primary"
                v-on:click="getComercialReleases()"
              >
                <span class="btn-inner--icon">
                  <i class="fa fa-search"></i>
                </span>
                <span class="btn-inner--text">Pesquisar</span>
              </base-button>
              <base-button
                @click="clearFilters"
                color="green"
                type="neutral"
                class="ml-3"
              >Limpar Pesquisa</base-button>
            </div>
          </div>
        </div>
        <span>Liberações Comerciais Pendentes</span>
      </div>
      <form>
        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-4"></div>
        </div>
      </form>
      <el-table
        v-loading="isLoading"
        class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light"
        :data="commercial_releases"
        ref="commercial_releases"
      >
        <el-table-column label="Status" prop="status" min-width="100px" sortable>
          <badge class="badge-dot mr-4" type>
            <i class="bg-warning"></i>Pendente
          </badge>
        </el-table-column>
        <el-table-column label="Data de criação" v-slot="{ row }" min-width="170px" sortable>
          {{ row.created_at | humanDate }}
        </el-table-column>
        <el-table-column label="Cliente" prop="client.razao_social" min-width="150px" sortable />
        <el-table-column label="Vendedor" prop="salesman.name" min-width="150px" sortable />
        <el-table-column label="Autor" prop="author.name" min-width="150px" sortable />
        <el-table-column label="Valor Total" v-slot="{ row }" min-width="150px" sortable>
          <span>{{
            row.value
              ? row.value.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              : 0
          }}</span>
        </el-table-column>

        <el-table-column label="Ações" width="120" v-slot="{ row }">
          <div class="row">
            <el-dropdown
              trigger="hover"
              class="dropdown"
              style="cursor: pointer;"
            >
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu
                class="dropdown-menu dropdown-menu-arrow show"
                slot="dropdown"
              >
                <a class="dropdown-item" href="#" @click="openCommercialReleaseDetailsModal(row)"
                  >Detalhes</a
                >
                <a class="dropdown-item" href="#" @click="openModalApprove(row)"
                  >Aprovar</a
                >
                <a
                  class="dropdown-item"
                  href="#"
                  @click="openModalDisapproval(row.id)"
                  >Reprovar</a
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Select,
  Option,
  Tag,
  DatePicker,
} from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import { ValidationProvider, extend } from "vee-validate";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import OrderItemForm from "@/views/PurchaseOrders/components/OrderItemForm";
import { required } from "vee-validate/dist/rules";
import CommercialReleaseDetails from "./components/CommercialReleaseDetails.vue";
import { mapState, mapActions } from 'vuex';

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});


export default {
  name: "app",
  components: {
    CommercialReleaseDetails,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PageTitle,
    Multiselect,
    ValidationProvider,
    flatPicker,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Tag.name]: Tag,
    Collapse,
    CollapseItem,
    OrderItemForm,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      modals: {
        modal0: false,
        modal1: false,
        modal2: false,
        commercialReleaseDetailsModal: false,
      },
      currentId: "",
      c_active_index: 0,
      purchase_orders: [],
      currentOrder: {},
      purchase_order: {
        client: {},
        client_info: {},
        order_items: [],
      },
      commercialDetailsOrders: {},
      filter: {
        created_at: null,
        end_date: null,
        client: null,
      },
      errors: [],
      commercial_releases: [],
      salesmans: [],
      clients: [],
      statuses: [],
      discounts: [],
      campaigns: [],
      payment_types: [],
      filtered: false,
      paginated_data: [],
      formData: {},
      expandedRow: {},
      status_classes: [
        "Registrado",
        "Esperando Aprovação",
        "Requisitada Alteração",
        "Aprovado",
        "Cancelado",
      ],
      price_tables: [],
      isLoading: false,
      selected_price_tables: [],
      real_estates: [],
      products: [],
      productLoading: false,
      validOrder: true,
      description: "",
      isTouchedType: false,
      orderItems: []
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.initRouteCommercialRelease(this.$route.params.id)
    } else {
      this.getComercialReleases();
    }
  },
  methods: {
    ...mapActions(['resetNotificationAction']),
    typeIsInvalid() {
      return this.isTouchedType && !this.description;
    },
    rowClicked(row) {
      if (this.expandedRow !== row) {
        this.$refs.purchase_orders.toggleRowExpansion(this.expandedRow);
        this.expandedRow = row;
      } else {
        this.expandedRow = null;
      }

      this.$refs.purchase_orders.toggleRowExpansion(row);
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    getComercialReleases(page) {
      this.isLoading = true;
      if (typeof page === "undefined") page = null;

      this.$http.secured
        .get("/api/v1/commercial_releases", { params: {
          page: page,
          start_date: this.filter.created_at || null,
          end_date: this.filter.end_date || null,
          q: {status: "pendent"}}
        })
        .then((response) => {
          this.paginated_data = response.data;
          this.commercial_releases = this.paginated_data["commercial_releases"];
          this.isLoading = false;
        })
        .catch((error) => {
          this.setError(error, "Something went wrong");
          this.isLoading = false;
        });
    },
    openModalApprove(row) {
      this.modals.modal1 = true;
      this.currentOrder = row;
      this.currentId = row.id;
      this.getOrderItems(row);
      this.getPurchaseOrder(row);
    },
    async getOrderItems(commercialRelease) {
      if (!commercialRelease.purchase_order_id) {
        return
      }
      const response = await this.$http.secured.get(`/api/v1/purchase_orders/${commercialRelease.purchase_order_id}/order_items`, { params: { unpaged: true } })
      this.orderItems = response.data
    },
    async getPurchaseOrder(commercialRelease) {
      if (!commercialRelease.purchase_order_id) {
        return
      }
      const response = await this.$http.secured.get(`/api/v1/purchase_orders/${commercialRelease.purchase_order_id}`)
      this.commercialDetailsOrders = response.data
    },
    openCommercialReleaseDetailsModal(row){
      this.currentOrder = row;
      this.getOrderItems(row);
      this.getPurchaseOrder(row);
      this.modals.commercialReleaseDetailsModal = true;
    },
    openModalDisapproval(id) {
      this.modals.modal2 = true;
      this.currentId = id;
    },
    changePage(page) {
      this.getComercialReleases(page);
    },
    async approve() {
      this.isTouchedType = true;

      if ((this.currentOrder.discount_percentage <= this.$currentUser().competence)) {
        this.$toasted.global.defaultError({
          msg: "Alçada não compatível com o valor do pedido! ",
        });
        return;
      }

      this.savingPeriod = true;

      await this.$http.secured.put(
        `/api/v1/commercial_releases/${this.currentId}`,
        { status: 1, description: this.description }
      );

      this.description = ''

      try {
        this.savingPeriod = false;
      } catch (error) {
        console.log(error);
        this.setError(error, "Something went wrong");
      }

      let elementPos = this.commercial_releases
        .map(function (commercial_release) {
          return commercial_release.id;
        })
        .indexOf(this.currentId);

      this.commercial_releases.splice(elementPos, 1);
      this.modals.modal1 = false;
      this.$toasted.global.defaultSuccess({
        msg: " Liberação comercial aprovada com sucesso ! ",
      });
    },
    async disapprove() {
      this.savingPeriod = true;

      await this.$http.secured.put(
        `/api/v1/commercial_releases/${this.currentId}`,
        { status: 2, description: this.description }
      );

      this.description = ''

      try {
        this.savingPeriod = false;
      } catch (error) {
        console.log(error);
        this.setError(error, "Something went wrong");
      }

      let elementPos = this.commercial_releases
        .map(function (commercial_release) {
          return commercial_release.id;
        })
        .indexOf(this.currentId);

      this.commercial_releases.splice(elementPos, 1);
      this.modals.modal2 = false;
      this.$toasted.global.defaultSuccess({
        msg: " Liberação comercial reprovada com sucesso ! ",
      });
    },
    clearFilters() {
      this.filter.created_at = null;
      this.filter.end_date = null;
    },
    async getCommercialRelease(id) {
      try {
        return await this.$http.secured.get(`/api/v1/commercial_releases/${id}`);
      } catch (error) {
        console.log("error: ", error)
      }
    },
    async initRouteCommercialRelease(commercialReleaseId) {
      this.isLoading = true;
      const response = await this.getCommercialRelease(commercialReleaseId)
      this.isLoading = false;
      this.commercial_releases = [response.data]
      this.paginated_data = { current: 1, count: 1, per_page: 10 }
    }
  },
  computed: {
    ...mapState({
      notificationAssociableId: state => state.notificationAssociableId
    }),
  },
  watch: {
    notificationAssociableId: function (newValue) {
      if (newValue) {
        this.initRouteCommercialRelease(newValue);
        this.resetNotificationAction(); // Reset the state to avoid multiple triggers
      }
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
